import axios from "axios";
import { configUrl } from "../config";

export const sendPreferenceListEmail = async ({
    pdfBlob,
    name,
    email
}) => {

    const formData = new FormData();

    formData.append(
        "reportFile",
        pdfBlob,
        "Medineer_Preference_List.pdf"
    );

    const response = await axios.post(
        `${configUrl.AssessmentServer}/api/Coupon/collegePredictorReportEmail/${encodeURIComponent(name)}/${encodeURIComponent(email)}`,
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }
    );

    return response.data;
};